var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fy"},[_c('label',{staticClass:"fy__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"fy__select"},[_c('pi-select',{attrs:{"value":_vm.year,"options":_vm.yearOptions,"searchable":false,"size":"sm"},on:{"input":function($event){_vm.year = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }